export enum EtaApproximationSource {
  REGION,
  PERSONALIZED
}
